import MoveableHelper from "moveable-helper";
import { Frame } from "scenejs";
import { fitPoints, getAreaSize, getOverlapSize, isInside } from "overlap-area";

import _ from "lodash";
import { WidgetRegistry } from "../widgets/registry";

export default class MoveableData extends MoveableHelper {
  constructor(editorSession, eventBus) {
    super({
      createAuto: true,
      useBeforeRender: true,
    });

    this.editorSession = editorSession;
    this.eventBus = eventBus;
    this.containers = [];
    this.selectedTargets = []

    this.reparentTarget = null;
  }

  setSelectedTargets(targets) {
    this.selectedTargets = targets;
  }

  getSelectedTargets() {
    return this.selectedTargets;
  }

  addContainer(container) {
    this.removeContainer(container);
    this.containers.push(container);
  }

  removeContainer(container) {
    if (!container) {
      return;
    }

    this.containers = this.containers.filter(item => {
      return item.id != container.id;
    });
  }

  onWidgetDrag = (e) => {
    this.onDrag(e);
    this.hitTest(e);
  }

  onWidgetDragEnd = (e) => {
    const moveableManager = e.currentTarget;
    const { target } = moveableManager.state;

    const widget = target.dataset.widgetId;

    if (this.reparentTarget) {
      this.eventBus.trigger('onParentChange', {
        widget: widget,
        parent: this.reparentTarget
      });
    }

    //this.reparentTarget = null;
  }

  hitTest = (e) => {
    if (_.size(this.containers) == 0) {
      return;
    }

    const moveableManager = e.currentTarget;
    const { target, pos1, pos2, pos3, pos4, targetClientRect } = moveableManager.state;
    const points = fitPoints([pos1, pos2, pos4, pos3], targetClientRect);

    const widget = target.dataset.widgetId;
    const widgetType = target.dataset.widgetType;
    const widgetConfig = WidgetRegistry.moveableConfig(this.editorSession, widgetType); 

    const currentParent = target.closest(`[data-container="true"]`);

    const parents = this.containers.filter(el => {
      if (el === target) {
        return false;
      }

      if(el.dataset.container !== 'true') {
        return false;
      }

      var canReparent = true;
      if(widgetConfig && widgetConfig.onReparent){
        canReparent = widgetConfig.onReparent(widget, el.id);
      }

      if(!canReparent){
        return false;
      }

      const clientRect = el.getBoundingClientRect();

      const { left, top, width, height } = clientRect;
      const size = getOverlapSize(points, [
        [left, top],
        [left + width, top],
        [left + width, top + height],
        [left, top + height],
      ]);

      const totalSize = getAreaSize(points);

      if (!size || !totalSize) {
        return false;
      }

      const rate = Math.min(100, size / totalSize * 100);
      return rate === 100;
    });
    const processedParents = [];
    parents.forEach(parent => {
      var found = parents.find(item => {
        return item != parent && parent.contains(item);
      });

      if (!found) {
        processedParents.push(parent);
      }
    });

    var request = {
      widget: widget
    }

    if (_.size(processedParents) > 0) {
      const parent = processedParents[0];

      const clientRect = parent.getBoundingClientRect();
      const { left, top, width, height } = clientRect;

      if (this.reparentTarget && this.reparentTarget.id === parent.id) {
        //No need to retrigger 
        return;
      }

      if (currentParent?.id != parent.id) {
        request = {
          ...request,
          parent: parent,
          rect: {
            top, left, width, height
          }
        }
      }
    }

    this.reparentTarget = request.parent;
    this.eventBus.trigger('onParentHover', request);
  }

  onResize = (e) => {
    const { direction } = e;
    if (direction[0] != 0 && direction[1] != 0) {

      const target = e.target;
      const rect = target.getBoundingClientRect();
      const frame = this.getFrame(target);

      const width = parseFloat(rect.width);
      const height = parseFloat(rect.height);
      const ratio = width / height;

      frame.set("width", `${e.width}px`);
      frame.set("height", `${e.width / ratio}px`);

      this.testDrag(e.drag);
    } else {
      this.testResize(e);
    }

    this.testRender(e.target);
  }

  testDrag(e) {
    const target = e.target;
    const translate = e.translate;

    const frame = this.getFrame(target);
    const tx = `${translate[0]}px`;
    const ty = `${translate[1]}px`;

    if (frame.has("transform", "translate")) {
      frame.set("transform", "translate", `${tx},${ty}`);
    } else {
      frame.set("transform", "translateX", tx);
      frame.set("transform", "translateY", ty);
    }

    const widgetId = e.target.dataset.widgetId;
    const type = e.target.dataset.widgetType;
    const widgetConfig = WidgetRegistry.moveableConfig(this.editorSession, type);

    if (widgetConfig && widgetConfig.onDrag) {
      var layout = frame.get();
      layout = widgetConfig.onDrag(layout, widgetId);
      const newFrame = new Frame(layout);
      this.setFrame(target, newFrame);
    }
  }
}
